module.exports = __webpack_public_path__ + "00cdb8b01a5a7aeac565ebede13a3f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/area-chart.jpg
// module id = 1829
// module chunks = 0